<template>
    <main>
        <v-header />
        <work-overlay class="header-breakpoint-hidden" />
        <div class="content-overlay" data-overlay />

        <slot />

        <v-footer />
    </main>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import WorkOverlay from '@/components/WorkOverlay.vue'

export default {
    name: 'app',
    components: {
        'v-header': Header,
        'v-footer': Footer,
        WorkOverlay
    }
}
</script>

<style lang="scss">
    @import '../assets/scss/main.scss';

</style>



// WEBPACK FOOTER //
// src/layouts/Layout.vue